import axios from 'axios';

import { appConfig } from '../config/app';

const UNAUTHORIZED_CODE = 401;
const UNAUTHORIZED_ERROR = [
  'Invalid authorization token',
  'Entity invalid custom validation',
];

const authHeader = (formData: boolean) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  // console.log('user', user);
  if (user && user.access_token) {
    return {
      'X-App-Info': `${appConfig?.SHORT_NAME}:2.0.0:web`,
      'Content-type': formData ? 'multipart/form-data' : 'application/json',
      Authorization: `Bearer ${user.access_token}`,
    };
  } else {
    return {
      'X-App-Info': `${appConfig?.SHORT_NAME}:2.0.0:web`,
      'Content-type': formData ? 'multipart/form-data' : 'application/json',
    };
  }
};

const authHeaderBff = (formData: boolean) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (user && user.bff_token) {
    return {
      'X-App-Info': `${appConfig?.SHORT_NAME}:2.0.0:web`,
      'Content-type': formData ? 'multipart/form-data' : 'application/json',
      Authorization: `Bearer ${user.bff_token}`,
    };
  } else {
    return {
      'X-App-Info': `${appConfig?.SHORT_NAME}:2.0.0:web`,
      'Content-type': formData ? 'multipart/form-data' : 'application/json',
    };
  }
};

const PUBLIC_HTTP = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'X-App-Info': `${appConfig?.SHORT_NAME}:2.0.0:web`,
    'Content-type': 'application/json',
  },
});

const PRIVATE_HTTP = (extra?: { formData: boolean }) => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: authHeader(!!extra?.formData),
  });

  instance.interceptors.response.use(
    (config) => config,
    (error) => {
      // handle the error
      if (
        error.response?.status === UNAUTHORIZED_CODE &&
        UNAUTHORIZED_ERROR.includes(error.response?.data?.error)
      ) {
        localStorage.removeItem('user');
        window.location.reload();
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

const PRIVATE_HTTP_BFF = (extra?: { formData: boolean }) => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BFF,
    headers: authHeaderBff(!!extra?.formData),
  });

  return instance;
};

export { PRIVATE_HTTP, PUBLIC_HTTP, PRIVATE_HTTP_BFF };
